import { render, staticRenderFns } from "./SidebarAnalytics.vue?vue&type=template&id=7809fa34"
import script from "./SidebarAnalytics.vue?vue&type=script&lang=ts"
export * from "./SidebarAnalytics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports